import { Injectable, NgZone } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreviewService {

  public offsetX = 0

  private data;
  private type;
  private completed = false;
  private gyro: boolean = false;

  private index: number = null;

  private geo: GeolocationPosition = null;
  private vehType: string;

  private previousTab: string = 'home';

  constructor() {



  }


  setGeo(geo: any) {
    this.geo = geo;
  }

  getGeo() {
    return this.geo;
  }

  setIndex(index: number) {
    this.index = index;
  }

  getIndex(): number {
    return this.index;
  }

  setData(data) {
    this.data = data
  }

  setDataResult(data) {
    this.geo = null;
    this.data = data
    this.completed = true
  }

  setType(type: string) {
    this.type = type;
  }


  getData(): any {
    return this.data
  }

  getType(): string {
    return this.type;
  }


  setDataType(data, type: string) {
    this.setData(data)
    this.setType(type)
  }

  clear() {

    if (!this.completed) return;

    console.log('clear')
    this.completed = false;
    this.data = null;
    this.type = null;
  }


  isCompleted(): boolean {
    return this.completed
  }

  setGyro(b: boolean) {
    this.gyro = b;
    console.log('set gyro: ' + this.gyro)
  }
  getGyro() {
    console.log('get gyro: ' + this.gyro)
    return this.gyro;
  }

  setPreviousTab(tab: string) {
    this.previousTab = tab;
    console.log('this.previousTab: ', this.previousTab);
  }

  getPreviousTab(): string {
    return this.previousTab;
  }

  clearPreviousTab() {
    this.previousTab = null;
  }

  async cropImage(base64: string): Promise<string> {
    return new Promise((resolve, reject) => {

      const img = new Image();

      img.onload = () => {

        const MAX_W = 1440;
        const MAX_H = 1080;
        const TARGET_RATIO = 4 / 3;

        let iw = img.naturalWidth || img.width;
        let ih = img.naturalHeight || img.height;

        // ✅ se è già entro i limiti, lascia originale
        if (iw <= MAX_W && ih <= MAX_H) {
          resolve(base64);
          return;
        }

        const srcRatio = iw / ih;

        let sx = 0, sy = 0, sw = iw, sh = ih;

        // crop centrato 4:3
        if (srcRatio > TARGET_RATIO) {
          sw = ih * TARGET_RATIO;
          sx = (iw - sw) / 2;
        } else {
          sh = iw / TARGET_RATIO;
          sy = (ih - sh) / 2;
        }

        const canvas = document.createElement('canvas');
        canvas.width = MAX_W;
        canvas.height = MAX_H;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('no ctx');
          return;
        }

        ctx.drawImage(
          img,
          sx, sy, sw, sh,
          0, 0, MAX_W, MAX_H
        );

        resolve(canvas.toDataURL('image/jpeg', 0.9));
      };

      img.onerror = reject;
      img.src = base64;
    });
  }

}
